import {Base64} from "js-base64";

export const encodeBase64 = (text: string) => {
    try {
        return Base64.encode(text);
    } catch (err) {
        return "Encoding error";
    }
};


export const decodeBase64 = (base64: string) => {
    try {
        return Base64
            .decode(base64)
    } catch (err) {
        return "Invalid Base64";
    }
};